import styles from './Error.module.scss'

export const TextError = ({text})=>{
    return <span className={styles.textError} >{text}</span>
}